export const common = {
  Title: "Lography",
  TitleDesc: "Log your stories.",
  Create: "Create",
  Save: "Save",
  Load: "Load",
  Close: "Close",
  Yes: "Yes",
  No: "No",
  OK: "OK",
  All: "All",
  Error: "Error",
  Accept: "Accept",
  Cancel: "Cancel",
  Delete: "Delete",
  Remove: "Remove",
  Accepted: "Accepted",
  Rejected: "Rejected",
  Name: "Name",
  User: "User",
  Users: "Users",
  Admin: "Admin",
  Administrator: "Administrator",
  Member: "Member",
  Members: "Members",
  Update: "Update",
  Upload: "Upload",
  Coupon: "Coupon",
  Use: "Use",
  Online: "Online",
  Offline: "Offline",
} as const;
